module.exports = __webpack_public_path__ + "static/media/one_way_corridors.fcc51296.svg";